export const configurationFile = {
  production: {
    "domain": "auth.scanbuy.com",
    "clientId": "ARx1Lg8I0Ujly7MGz62rZGe1DAHxJ1H4",
    "audience" : "https://scanbuyportal.auth0.com/api/v2/",
    "API_DOMAIN_NAME":"https://portal.scanbuy.com",
    "API_GRAPHQL" : "https://portal.scanbuy.com/graphql",
    "LOGOUT_URL" : "https://auth.scanbuy.com/v2/logout?federated&returnTo=https://portal.scanbuy.com&client_id=ARx1Lg8I0Ujly7MGz62rZGe1DAHxJ1H4"
  },
  staging: {
    "domain": "scanbuyportal-stg.auth0.com",
    "clientId": "4geVctksSp786VLrPJrmbUfdCOrVQKhR",
    "audience" : "https://scanbuyportal-stg.auth0.com/api/v2/",
    "API_DOMAIN_NAME":"https://stgportal.scanbuy.com",
    "API_GRAPHQL" : "https://stgportal.scanbuy.com/graphql",
    "LOGOUT_URL" : "https://scanbuyportal-dev.auth0.com/v2/logout?federated&returnTo=http%3A%2F%2Fwww.scanbuy.com&client_id=PJN4UgXuzJvwaTjw7ywEpO3GlNZo3Bs3"
  },
  stg_k8s: {
    "domain": "scanbuyportal-stg.auth0.com",
    "clientId": "4geVctksSp786VLrPJrmbUfdCOrVQKhR",
    "audience" : "https://scanbuyportal-stg.auth0.com/api/v2/",
    "API_DOMAIN_NAME":"https://portal.stg.scanbuy.com",
    "API_GRAPHQL" : "https://portal.stg.scanbuy.com/graphql",
    "LOGOUT_URL" : "https://scanbuyportal-stg.auth0.com/v2/logout?federated&returnTo=http%3A%2F%2Fportal.stg.scanbuy.com&client_id=4geVctksSp786VLrPJrmbUfdCOrVQKhR"
  },
  development: {
    "domain": "scanbuyportal-dev.auth0.com",
    "clientId": "PJN4UgXuzJvwaTjw7ywEpO3GlNZo3Bs3",
    "audience" : "https://scanbuyportal-dev.auth0.com/api/v2/",
    "API_DOMAIN_NAME":"https://devportal.scanbuy.com",
    "API_GRAPHQL" : "https://devportal.scanbuy.com/graphql",
    "LOGOUT_URL" : "https://scanbuyportal-dev.auth0.com/v2/logout?federated&returnTo=http%3A%2F%2Fwww.scanbuy.com&client_id=PJN4UgXuzJvwaTjw7ywEpO3GlNZo3Bs3"
  },
  test: {
    "domain": "scanbuyportal-dev.auth0.com",
    "clientId": "PJN4UgXuzJvwaTjw7ywEpO3GlNZo3Bs3",
    "audience" : "https://scanbuyportal-dev.auth0.com/api/v2/",
    "API_DOMAIN_NAME":"http://localhost:3000",
    "API_GRAPHQL" : "https://devportal.scanbuy.com/graphql",
    "LOGOUT_URL" : "https://scanbuyportal-dev.auth0.com/v2/logout?federated&returnTo=http%3A%2F%2Fwww.scanbuy.com&client_id=PJN4UgXuzJvwaTjw7ywEpO3GlNZo3Bs3"
  },
  localOld: {
    // "domain": "scanbuyportal-local.auth0.com",
    // "clientId": "uRYslHe1uNSpvD8j4lEesimST0qxkMTQ",
    // "audience" : "https://scanbuyportal-local.auth0.com/api/v2/",
    "API_DOMAIN_NAME":"https://devportal.scanbuy.com",
    "API_GRAPHQL" : "http://localhost:4000/local/graphql",
    "domain": "scanbuyportal-dev.auth0.com",
    "clientId": "PJN4UgXuzJvwaTjw7ywEpO3GlNZo3Bs3",
    "audience" : "https://scanbuyportal-dev.auth0.com/api/v2/",
    // "API_DOMAIN_NAME":"http://localhost:4000/local",
    // "API_GRAPHQL" : "http://localhost:4000/local/graphql"
  },
  local: {
    // "domain": "scanbuyportal-local.auth0.com",
    // "clientId": "uRYslHe1uNSpvD8j4lEesimST0qxkMTQ",
    // "audience" : "https://scanbuyportal-local.auth0.com/api/v2/",
    "API_DOMAIN_NAME":"https://devportal.scanbuy.com",
    "API_GRAPHQL" : "http://localhost:4000/local/graphql",
    "domain": "scanbuyportal-dev.auth0.com",
    "clientId": "PJN4UgXuzJvwaTjw7ywEpO3GlNZo3Bs3",
    "audience" : "https://scanbuyportal-dev.auth0.com/api/v2/",
    "LOGOUT_URL" : "https://scanbuyportal-dev.auth0.com/v2/logout?federated&returnTo=http%3A%2F%2Fwww.scanbuy.com&client_id=PJN4UgXuzJvwaTjw7ywEpO3GlNZo3Bs3"
    // "API_DOMAIN_NAME":"http://localhost:4000/local",
    // "API_GRAPHQL" : "http://localhost:4000/local/graphql"
  }
};

export const API_URL_ROOT = configurationFile[process.env["REACT_APP_ENV"]].API_DOMAIN_NAME;
export const API_URL_LOCAL = configurationFile[process.env["REACT_APP_ENV"]].API_GRAPHQL;
export const POWER_EDITORS = ["didier@scanbuy.com"]
export const LOGROCKET_APP_ID = "oj3ojm/portal-jjukb";
